if (!customElements.get('predictive-search')) {  
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.isOpen = false;
      this.isInit = false;
      this.searchInput = null;
      this.emptyResults = false;
      this.indexPrefix = this.dataset.prefix;
      this.headerIndex = `${this.indexPrefix}products_header_search${getSuffix()}`;
      this.querySuggestions = `${this.indexPrefix}products_query_suggestions${getSuffix()}`;
    }

    connectedCallback() {
      if (this.isInit) return;     
        
      if (window.algoliaIsLoaded) {
        this.init();
        return;
      }       
      
      window.addEventListener('algolia:script-loaded', () => {
        this.init();
      });
    }
    
    init() {
      if (this.isInit) return;     
      this.isInit = true;

      this.addDelegatedClickListeners();
    }
    
    addDelegatedClickListeners() {
      document.addEventListener('keyup', (e) => {    
        if (this.isOpen && e.key === "Escape") {
          this.close();
          return;
        }
        if (!this.isOpen || !e.target.closest('[data-search-toggle]')) return;    
        this.fetchSearchResults(this.searchInput.value);
      });
      
      document.addEventListener('click', (e) => {
        if (e.target.closest('[data-search-toggle="close"]')) {
          this.close();
          return;
        }

        if (e.target.closest('predictive-search')) return;
        
        if (e.target.closest('[data-search-toggle="open"]')) {
          this.searchInput = e.target.closest('[data-search-toggle="open"]');
          this.open();
          if (!this.emptyResults) {
            this.algoliaClient = window.algoliasearch('B8RIKEI9OC', '307ccfad891594b0e4b982aa6a862676');
            this.algoliaClient.initIndex(this.headerIndex);
            this.fetchSearchResults('');
            this.emptyResults = true;
          }
          return;
        }
        
        this.close();
      });
    }
    
    
    open() {
      this.isOpen = true;
      this.classList.remove('hidden');
      document.body.classList.add('scroll-lock');
      document.querySelector('[data-main-nav]')?.classList.add('overlay', 'blur');
      document.querySelector('site-header')?.closeAllMenus();
      
      const searchWrapper = this.querySelector('[data-search-wrapper]');
      searchWrapper.style.top = `${this.searchInput.getBoundingClientRect()?.bottom}px`;
      document.querySelector('[data-mobile-overlay]')?.classList.add('open-on-mobile');

      setTimeout(() => {
        this.classList.add('active');
        if (window.matchMedia('(max-width: 768px)').matches) {
          document.querySelector('input[name="q"]')?.focus().setSelectionRange(0, 999);
        }
      }, 10);

      const gorgias_container = document.querySelector('#gorgias-chat-container');
      if (gorgias_container) gorgias_container.style.zIndex = '-1';
      
      // document.querySelectorAll('.needsclick').forEach((needsclick_el) => {
      //   needsclick_el.style.zIndex = '-1';
      // });
    }

    close() {
      document.body.classList.remove('scroll-lock');
      this.isOpen = false;
      this.classList.remove('active');
      document.querySelector('[data-mobile-overlay]')?.classList.remove('open-on-mobile');
      document.querySelector('[data-main-nav]')?.classList.remove('blur');
      document.documentElement.classList.remove('cloud-search-mobile-open');

      setTimeout(() => {
        this.classList.add('hidden');
        document.querySelector('[data-main-nav]')?.classList.remove('overlay');
      }, 501);

      let submenu_open = false;
      const submenu_buttons = document.querySelectorAll('[data-action="open-submenu"]');

      submenu_buttons.forEach(button => {
        if (button.classList.contains('active')) submenu_open = true;
      });

      const gorgias_container = document.querySelector('#gorgias-chat-container');
      if (gorgias_container) gorgias_container.style.zIndex = submenu_open ? '-1' : '31';
      
      // document.querySelectorAll('.needsclick').forEach((needsclick_el) => {
      //   needsclick_el.style.zIndex = submenu_open ? '-1' : '31';
      // });
    }
    
    buildResultsPane(products, querySuggestions, query) {
      const searchWrapper = this.querySelector('[data-search-wrapper]');
      searchWrapper.innerHTML = `
        ${query ? 
          products.slice(0, 2).map((product) => `
            <a href="/products/${product.handle}" class="flex flex-col gap-4 w-full text-primaryDark hover:text-primaryBrand">
              <img class="aspect-[389/317] block rounded-lg border border-mercury w-full h-full object-cover object-center max-w-[389px]" width="389" height="317" src="${product.image}" alt="${product.title}">
              <span>${product.title}</span>
            </a>
          `).join('')
          : 
          this.querySelector('[data-promo-tiles]').innerHTML
        }
        <div class="md:px-6 order-first md:order-none">
          <div class="flex items-center w-full justify-between mb-6 pt-2 pb-4 border-b border-mercury">
            <strong class="block flex-grow leading-none tracking-[-0.085px]">${query ? 'Suggestions:' : 'Trending Searches'}</strong>
            <button aria-label="close search panel" class="w-4 h-4 flex items-center justify-center md:hidden" data-search-toggle="close">
              <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 26 24" fill="none">
                <line x1="1.33273" y1="23.6464" x2="23.9601" y2="1.019" stroke="currentColor"/>
                <line x1="2.03983" y1="0.646416" x2="24.6672" y2="23.2738" stroke="currentColor"/>
              </svg>
            </button>
          </div>
          <ul class="flex flex-col gap-4">
            ${querySuggestions.map((suggestion) => `
              <li class="leading-5">
                <a class="no-underline text-primaryDark hover:text-primaryBrand" href="/search?q=${suggestion.query}">
                  ${suggestion.query}
                </a>
              </li>
            `).join('')}
          </ul>
        </div>
      `;
    }
    
    async fetchSearchResults(query) {
      await this.algoliaClient.multipleQueries([{
        indexName: this.headerIndex,
        params: {
          hitsPerPage: 9,
          page: 0,
          query,
          filters: 'NOT tags:base_product AND NOT tags:hide_product'
        }
      },{
        indexName: this.querySuggestions,
        params: {
          query,
          hitsPerPage: 7,
        }
      }], 1, false).then((res) => {
        if (!this.defaultProducts) this.defaultProducts = res?.results[0]?.hits;
        if (!res.results[0]?.hits.length) {
          this.buildResultsPane(this.defaultProducts, res.results[1]?.hits, '');
          return;
        }
        if ((res.results[0]?.hits.length < 3) && this.defaultProducts) {
          this.buildResultsPane([...res.results[0]?.hits, res.results[1]?.hits, ...this.defaultProducts], res?.results[0]?.query);
          return;
        }
        this.buildResultsPane(res?.results[0]?.hits, res.results[1]?.hits, res?.results[0]?.query);
      });
    }
  }

  customElements.define('predictive-search', PredictiveSearch);
}